import { useField } from 'react-final-form'
import { useGate } from 'gates'
import {
  progressiveDisclosureValidator,
  VALIDATOR_EMAIL,
  VALIDATOR_PHONE
} from 'validation'

// CAT-4561 Variant C swaps the contact field order: email, then phone,
// instead of phone, then email. Whichever field ends up last differs by
// variant, and both PersonalForm (choosing which field order to render) and
// NavigationWrapper (gating the legal hint) need to agree on it — this
// hook is the single source of truth so they can't drift out of sync.
export const useCat4561ContactFieldOrder = (debtorPath: string) => {
  const isEmailFirstVariation = useGate('cat4561EmailFirstVariation')
  const phoneField = useField(`${debtorPath}.contact.phoneNumber`, {
    subscription: { value: true }
  })
  const emailField = useField(`${debtorPath}.contact.email`, {
    subscription: { value: true }
  })

  // Email-first (Variant C) reveals phone last, gated on email validity;
  // phone-first (control/Variant B) reveals email last, gated on phone
  // validity.
  const lastFieldValidator = isEmailFirstVariation
    ? progressiveDisclosureValidator(VALIDATOR_EMAIL)
    : progressiveDisclosureValidator(VALIDATOR_PHONE)
  const lastFieldGateValue = isEmailFirstVariation
    ? emailField.input.value
    : phoneField.input.value

  return { isEmailFirstVariation, lastFieldValidator, lastFieldGateValue }
}
